import { render } from "./smDetails.vue?vue&type=template&id=e70bf100"
import script from "./smDetails.vue?vue&type=script&lang=js"
export * from "./smDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__